import React from "react";

import LeaderboardPlayer from "components/Project/Leaderboard/LeaderboardPlayer";

import Link from "components/shared/Link/Link";
import localize from "lang/localize";

/**
 * CUSTOM FOR GRAB:
 * - Display crown for Top 10 players
 */
class GrabLeaderboardPlayer extends LeaderboardPlayer {
  /**
   * Render a single player on the leaderboard
   */
  render() {
    let image = this.props.image;
    let name = this.props.name;
    let link = this.getLink();

    return (
      <Link to={link}>
        <div className="leaderboard-player">
          <div
            className={
              "pure-g bottommargin" +
              (this.props.self ? " self highlightborder" : "")
            }
          >
            <div className="pure-u-3-24 relative">
              <h4 className="leaderboard-rank">{this.props.rank}</h4>
            </div>
            <div className="pure-u-3-24">
              {/* Render crown icon for Top 10 Players */}
              {this.props.rank <= 10 && (
                <div id="crown" className="photo-icon-wrap">
                  <span className="leaderboard-champion" />
                </div>
              )}
              <span className="square-image-wrapper">
                <span className="square-image circle">
                  <img src={image} alt={name} />
                </span>
              </span>
            </div>
            <div className="pure-u-1-24" />
            <div className="pure-u-10-24 relative">
              <div dangerouslySetInnerHTML={{ __html: name }} />
            </div>
            <div className="pure-u-6-24 relative">
              <div className="textright">
                <strong>{this.props.points.abbreviateNumber()}</strong>
                <br />
                <span className="smalltext">
                  {localize("points_just_text", this.props.language)}
                </span>
              </div>
            </div>
            <div className="pure-u-1-24" />
          </div>
        </div>
      </Link>
    );
  }
}

export default GrabLeaderboardPlayer;
